function cloneType(oldType) {
  // deep clone: let's just go via JSON
  return JSON.parse(JSON.stringify(oldType));
}

export {cloneType}